module.exports = __webpack_public_path__ + "static/media/cancel_appointment.7e75005c.svg";